import "./_successor-table-row.scss";
import {Member} from '../../model/EstateFlowchartTypes'
import {DraggableProvided} from 'react-beautiful-dnd'
import React from 'react'
import MemberDropdownMultiselect from '../FormContent/MemberDropdownMultiselect/MemberDropdownMultiselect'
import {SuccessorRow} from "./SuccessorTable";

type SuccessorTableRowProps = Readonly<{
    id: string,
    row: SuccessorRow,
    index: number,
    dropdownHeight: number,
    includeNT?: boolean,
    provided: DraggableProvided,
    onChangeSuccessor: (options: Member[], index: number) => void,
    onDeleteSuccessor: (order: number) => void,
}>

function SuccessorTableRow({
                               id,
                               row,
                               index,
                               dropdownHeight,
                               provided,
                               includeNT,
                               onChangeSuccessor,
                               onDeleteSuccessor
                           }: SuccessorTableRowProps): JSX.Element {

    const shrinkWrapDropdown = row.successors.length * 34 < 280 ? (row.successors.length * 34) + 20 : 280
    return (
        <div id={id} className="successor-row"
             data-testid={`successor-trustees-dropdown-${index}`} key={index}
             ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
            <i className="dds-icons icon drag__icon" aria-hidden="true">drag_vertical</i>
            <MemberDropdownMultiselect
                onChange={(options: Member[]) => {
                    onChangeSuccessor(options, index)
                }}
                className="successorTable-dds-ms"
                options={row.successors}
                panelHeight={dropdownHeight === 0 ? shrinkWrapDropdown : dropdownHeight}
                placeholder="Select or Add New"
                required={false}
                selectedOptions={row.selectedSuccessors}
                includeNT={includeNT}
                useTags={true}
                helperText=''
            />

            <i className="dds-icons icon paddingright-md paddingleft-md delete-successor-trustee"
               data-testid="successor-row-delete" onClick={() => onDeleteSuccessor(row.order)}
               aria-hidden="true">delete</i>
        </div>
    )
}

export default SuccessorTableRow